<template>
  <a-modal v-model="visible" :title="title" @cancel="closeModal(true)" width="80%">
    <a-steps :current="stepCurrent" style="margin-bottom: 25px">
      <a-step title="选择新内容" />
      <a-step title="选择课程" />
      <a-step title="设置内容参数" />
      <a-step title="确认新内容" />
    </a-steps>
    <template v-if="stepCurrent == 0">
      <div @keyup.enter="getPageList()">
        <a-form layout="inline" class="searchForm search-form">
          <a-form-item label="游戏名称">
            <a-input allowClear placeholder="请输入游戏名称" v-model.trim="searchForm.name" />
          </a-form-item>
          <a-form-item label="质量标准" v-if="activeTab < 3">
            <a-select allowClear v-model="searchForm.classifyTag" placeholder="请选择" style="width: 180px">
              <a-select-option :value="1">商用</a-select-option>
              <a-select-option :value="4">科研</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="getPageList(true)">查询</a-button>
          </a-form-item>
        </a-form>
      </div>
      <a-tabs v-model="activeTab" @change="getPageList(true)">
        <a-tab-pane :key="1" tab="添加测评游戏"><GameList v-if="activeTab == 1" ref="currentTableRef" /> </a-tab-pane>
        <a-tab-pane :key="2" tab="添加训练游戏"><GameList v-if="activeTab == 2" ref="currentTableRef" /> </a-tab-pane>
        <a-tab-pane :key="3" tab="添加题目壳"><ShellList v-if="activeTab == 3" ref="currentTableRef" /></a-tab-pane>
      </a-tabs>
    </template>
    <selectExpCourse v-if="stepCurrent == 1" ref="selectExpCourseRef" />
    <settingContentParams v-if="stepCurrent == 2" ref="settingContentParamsRef" :contentData="state.contents" />
    <confirmContent v-if="stepCurrent == 3" ref="confirmContentRef" :contentData="state.confirmData" />
    <a-row slot="footer">
      <a-button @click="prevStep">{{ stepCurrent == 0 ? '取消' : '上一步' }}</a-button>
      <a-button type="primary" @click="handleNext" :loading="confirmLoading">{{ stepCurrent == 3 ? '确定' : '下一步' }}</a-button>
    </a-row>
  </a-modal>
</template>

<script>
import GameList from './component/GameList.vue'
import ShellList from './component/ShellList.vue'
import selectExpCourse from '../selectExpCourse.vue'
import confirmContent from '../confirmContent.vue'
import settingContentParams from '../settingContentParams.vue'
import { CourseResource } from '../../../../../../../utils/http'

export default {
  name: 'SelectGameContent',
  components: { GameList, ShellList, selectExpCourse, settingContentParams, confirmContent },
  props: {
    title: {
      type: String,
      default: '选择内容',
    },
  },
  provide() {
    return {
      getCommonState: () => ({
        activeTab: this.activeTab,
        searchForm: this.searchForm,
        rowSelection: this.rowSelection,
      }),
    }
  },

  data() {
    return {
      visible: false,
      activeTab: 1,
      stepCurrent: 0,
      selectedRowKeys: [],
      selectedRows: [],
      confirmLoading: false,
      searchForm: {
        name: undefined,
        versionName: undefined,
        scientificName: undefined,
        firstAbilityId: undefined,
        classifyTag: undefined,
      },
      state: {
        contents: [],
        courses: [],
        confirmData: [],
      },
    }
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onSelect: (record, selected) => {
          if (selected) {
            this.selectedRowKeys.push(record.id)
            this.selectedRows.push(record)
          } else {
            this.selectedRowKeys = this.selectedRowKeys.filter((key) => record.id != key)
            this.selectedRows = this.selectedRows.filter((item) => record.id != item.id)
          }
        },
      }
    },
  },
  methods: {
    generateContent() {
      const result = []
      this.state.contents.forEach((v) => {
        this.state.courses.forEach((item) => {
          result.push({
            ...v,
            ...item,
            contentName: v.name,
            contentId: v.id,
            courseName: item.name || item.courseName,
            courseId: item.id,
            composeMode: item.composeMode,
            courseType: item.courseType,
            contentAbility: JSON.parse(JSON.stringify(v.contentAbility)),
          })
        })
      })
      return result
    },
    showModal(options = {}) {
      return new Promise((resolve, reject) => {
        this._resolve = resolve
        this._reject = reject
        this.visible = true
        this.getPageList(true)
        if (options.selected) {
          this.selectedRowKeys = options.selected
        }
      })
    },
    closeModal(isReject, params) {
      this.visible = false
      isReject ? this._reject(params) : this._resolve(params)
      this.selectedRowKeys = []
      this.selectedRows = []
      this.stepCurrent = 0
      this.state.contents = []
      this.state.courses = []
    },
    prevStep() {
      switch (this.stepCurrent) {
        case 0:
          this.closeModal(true)
          break
        case 1:
          this.stepCurrent--
          this.state.courses = this.$refs['selectExpCourseRef'].selectedRows
          this.$nextTick(() => {
            this.getPageList(true)
          })
          break
        case 2:
          this.stepCurrent--
          this.$nextTick(() => {
            this.$refs['selectExpCourseRef'].getPageList(1)
            this.$refs['selectExpCourseRef'].selectedRows = this.state.courses
            this.$refs['selectExpCourseRef'].selectedRowKeys = this.state.courses.map((v) => v.id)
          })
          break
        case 3:
          this.stepCurrent--
          break
      }
    },
    async handleNext() {
      const next = (nextTick) => {
        this.stepCurrent++
        this.$nextTick(() => {
          nextTick && nextTick()
        })
      }
      const contentTypeName = ['', '测评游戏', '训练游戏', '题目壳', '课程视频', '亲子游戏']
      switch (this.stepCurrent) {
        case 0:
          if (!this.selectedRowKeys.length) {
            return this.$message.error('请选择内容')
          }
          this.state.contents = this.selectedRows.map((item) => ({
            ...item,
            executionsNumber: item.contentType === 2 ? 5 : 1,
            contentDisplayOrder: 1,
            contentTypeName: contentTypeName[item.contentType],
            isLinkVedio: false,
            isSetting: true,
            isRegularContent: false,
          }))
          next(() => {
            this.$refs['selectExpCourseRef'].getPageList(1)
            this.$refs['selectExpCourseRef'].selectedRows = this.state.courses
            this.$refs['selectExpCourseRef'].selectedRowKeys = this.state.courses.map((v) => v.id)
          })
          break

        case 1:
          this.state.courses = this.$refs['selectExpCourseRef'].selectedRows
          if (!this.state.courses.length) {
            return this.$message.error('请选择课程')
          }
          next()
          break

        case 2:
          this.state.confirmData = this.generateContent()
          next()
          break
        case 3:
          const params = []
          this.state.confirmData.forEach((v) => {
            params.push({
              courseId: v.courseId,
              contentId: v.contentId,
              contentAbilityIds: v.contentAbility.filter((v) => v.isSetting).map((v) => v.id),
              isLinkVedio: v.isLinkVedio,
              displayOrder: v.contentDisplayOrder,
              executionsNumber: v.executionsNumber,
            })
          })
          this.confirmLoading = true
          await CourseResource.addExperienceList(params).finally(() => {
            this.confirmLoading = false
          })
          this.closeModal(false, { ...this.state })
          break
      }
    },
    getPageList(reset) {
      this.$nextTick(() => {
        this.$refs['currentTableRef'].getPageList(reset)
      })
    },
  },
}
</script>
